import { useQuery } from 'react-query';
import { reviewService } from 'review/services/reviewService';

export function useGetReviewQuery(matchId, pointJoinKey) {
  return useQuery(['reviewService_getReview'], () => reviewService.getReview({ matchId, pointJoinKey }));
}
